import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

export const SecondaryNav = props => {
  const { link, classes, t, currentPath } = props;

  return (
    <ListItem
      button
      component={NavLink}
      to={link.path || '#'}
      activeClassName={classes.primaryMenuActive}
      selected={link.path === currentPath}
      classes={{
        button: classNames(classes.menuDefaultColor),
        root: classNames(classes.menuRow)
      }}
    >
      <ListItemText
        primary={t(link.name)}
        classes={{
          primary: classNames(
            classes.menuText,
            classes.menuDefaultColor,
            'menuText'
          ),
          root: classNames(classes.secondaryMenuText, classes.menuDefaultColor)
        }}
      />
    </ListItem>
  );
};

SecondaryNav.propTypes = {
  classes: PropTypes.object.isRequired,
  link: PropTypes.object.isRequired
};

export default withNamespaces()(SecondaryNav);
